// extracted by mini-css-extract-plugin
module.exports = {"chatButton":"styles_chatButton__1Lrb_","chatIframeWrapper":"styles_chatIframeWrapper__2zL0f","messageBadge":"styles_messageBadge__1Wx9f"};